import Apartments from '../screens/apartments';
export default Apartments;
